function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import { asMultiStyleConfig } from '../../utils/theme';
import typography from '../foundations/typography';
import Input, { sizes as inputSizes } from './input';
var parts = ['container', 'field', 'addon'];
var {
  variants,
  defaultProps
} = Input;
var baseStyleRoot = {
  '--number-input-stepper-width': '20px',
  '--number-input-field-padding': 'calc(var(--number-input-stepper-width) + 0.5rem)'
};

//@ts-ignore @Kia Storm: Throws errors now types are constrained.
var baseStyleField = props => {
  var _Input$baseStyle;
  return (_Input$baseStyle = Input.baseStyle(props)) === null || _Input$baseStyle === void 0 ? void 0 : _Input$baseStyle.field;
};
var baseStyleStepperGroup = {
  width: 'var(--number-input-stepper-width)',
  right: 3
};
var baseStyleStepper = {
  color: 'inherit',
  pr: 2,
  _active: {
    bg: 'gray.200'
  },
  _groupDisabled: {
    color: 'grey.800'
  },
  _disabled: {
    color: 'grey.800',
    cursor: 'not-allowed'
  }
};
var baseStyle = props => ({
  root: baseStyleRoot,
  field: baseStyleField(props),
  stepperGroup: baseStyleStepperGroup,
  stepper: baseStyleStepper,
  incrementIcon: {
    width: '.875rem',
    height: '.875rem',
    '&:before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg stroke='%230360A6' fill='%230360A6' stroke-width='0' viewBox='0 0 320 512' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M177 159.7l136 136c9.4 9.4 9.4 24.6 0 33.9l-22.6 22.6c-9.4 9.4-24.6 9.4-33.9 0L160 255.9l-96.4 96.4c-9.4 9.4-24.6 9.4-33.9 0L7 329.7c-9.4-9.4-9.4-24.6 0-33.9l136-136c9.4-9.5 24.6-9.5 34-.1z'%3E%3C/path%3E%3C/svg%3E\");",
      backgroundRepeat: 'no-repeat'
    }
  },
  decrementIcon: {
    width: '.875rem',
    height: '.875rem',
    '&:before': {
      content: '""',
      display: 'block',
      width: '100%',
      height: '100%',
      backgroundSize: 'contain',
      backgroundPosition: 'center',
      backgroundImage: "url(\"data:image/svg+xml,%3Csvg stroke='%230360A6' fill='%230360A6' stroke-width='0' viewBox='0 0 320 512' height='1em' width='1em' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M143 352.3L7 216.3c-9.4-9.4-9.4-24.6 0-33.9l22.6-22.6c9.4-9.4 24.6-9.4 33.9 0l96.4 96.4 96.4-96.4c9.4-9.4 24.6-9.4 33.9 0l22.6 22.6c9.4 9.4 9.4 24.6 0 33.9l-136 136c-9.2 9.4-24.4 9.4-33.8 0z'%3E%3C/path%3E%3C/svg%3E\");",
      backgroundRepeat: 'no-repeat'
    }
  }
});
var getSize = size => {
  var _sizeStyle$field;
  var sizeStyle = inputSizes[size];
  var radius = {
    md: 'md'
  };
  var resolvedFontSize = typography.fontSizes[sizeStyle === null || sizeStyle === void 0 ? void 0 : (_sizeStyle$field = sizeStyle.field) === null || _sizeStyle$field === void 0 ? void 0 : _sizeStyle$field['fontSize']];
  return {
    field: _objectSpread(_objectSpread({}, sizeStyle === null || sizeStyle === void 0 ? void 0 : sizeStyle.field), {}, {
      paddingRight: 'var(--number-input-field-padding)',
      verticalAlign: 'top'
    }),
    stepper: {
      color: 'blue.600',
      fontSize: "calc(".concat(resolvedFontSize, " * 0.75)"),
      _first: {
        borderTopRightRadius: radius[size]
      },
      _last: {
        borderBottomRightRadius: radius[size]
      }
    }
  };
};
var sizes = {
  md: getSize('md')
};
export default asMultiStyleConfig({
  parts,
  baseStyle,
  sizes,
  variants,
  defaultProps
});